import { gql } from "@apollo/client";
import { client } from "api";
import {
  CompanySignatureResult,
  toCompanySignatureError,
} from "./companySignatureResult";

interface MutationResult {
  presignCompanyPrecontracts: boolean | null;
}

interface MutationParams {
  params: {
    documentIds: number[];
  };
}

export const presignCompanyPrecontracts = async (
  documentIds: number[],
): Promise<CompanySignatureResult> => {
  if (documentIds.length === 0) return { success: false };

  try {
    const response = await client.mutate<MutationResult, MutationParams>({
      mutation: gql`
        mutation PresignCompanyPrecontracts(
          $params: SignCompanyPrecontractsParams!
        ) {
          presignCompanyPrecontracts(params: $params)
        }
      `,
      variables: {
        params: { documentIds },
      },
    });
    return { success: !!response.data?.presignCompanyPrecontracts };
  } catch (error) {
    return toCompanySignatureError(error);
  }
};
